import {
  HeadingColorMap,
  HeadingVariantMap,
  TextAlignmentMap,
  TextColorMap,
  TextThemeColorMap,
  TextVariantMap,
} from '../../types/v2/text';

export const THEME_COLOR: TextThemeColorMap = {
  primary: 'text-primary',
  secondary: 'text-secondary',
  accent: 'text-accent',
  neutral: 'text-neutral',
  'base-100': 'text-base-100',
  'base-200': 'text-base-200',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
};

export const DEFAULT_TEXT_COLOR: TextColorMap = {
  base: 'text-primary',
  navigation: 'text-info',
  'mobile-navigation': 'text-primary',
  'active-navigation': 'text-primary',
  supplementary: 'text-info',
  special: 'text-info',
  tag: 'text-neutral',
  username: 'text-primary',
  'alt-navigation': 'text-primary',
  tooltip: 'text-info',
  link: 'text-accent',
  label: 'text-info',
  data: 'text-primary',
  month: 'text-info',
  day: 'text-primary',
  tab: 'text-primary',
  'overlay-text': 'text-primary',
};

export const DEFAULT_HEADING_COLOR: HeadingColorMap = {
  primary: 'text-primary',
  secondary: 'text-primary',
  tertiary: 'text-neutral',
};

export const TEXT_ALIGNMENT: TextAlignmentMap = {
  center: 'text-center w-full',
  left: 'text-left',
  right: 'text-right',
};

export const TEXT_VARIANT: TextVariantMap = {
  base: 'block break-words text-sm font-light',
  navigation: 'inline-block capitalize',
  'active-navigation': 'inline-block capitalize font-medium',
  supplementary: 'block text-xs',
  special: 'inline-block font-base uppercase text-sm',
  'alt-navigation': 'inline-block font-base capitalize text-base',
  tag: 'inline-block whitespace-nowrap font-light text-[0.6rem] uppercase',
  username: 'inline-block font-medium',
  tooltip: 'inline-block text-[0.6rem] font-light',
  link: 'inline-block text-sm',
  'mobile-navigation': 'font-light text-base capitalize',
  label:
    'mobile:text-xs uppercase tracking-wide font-medium inline-block whitespace-nowrap',
  data: 'mobile:text-sm tablet-sm:text-base uppercase tracking-wide font-medium inline-block',
  month:
    'mobile:text-sm tablet-sm:text-base uppercase tracking-wide inline-block',
  day: 'mobile:text-xl tablet-sm:text-3xl uppercase tracking-wide font-medium inline-block',
  tab: 'text-sm capitalize tracking-sm inline-block',
  'overlay-text': 'tracking-wide inline-block',
};

export const HEADING_VARIANT: HeadingVariantMap = {
  primary: 'block text-xl font-bold leading-6',
  secondary: 'block text-lg font-medium leading-5',
  tertiary: 'block text-base font-medium ',
};

export const DEFAULT_TAG_STYLE = ' bg-white px-1.5 py-1 rounded';
